import type { MatchReviewRow } from '../../types/matching';
import { ActionButtons } from './ActionButtons';

interface QueueRowExpandedProps {
  row: MatchReviewRow;
}

interface FieldRow {
  label: string;
  ncesValue: string | null | undefined;
  blastValue: string | null | undefined;
}

function asString(v: unknown): string | null {
  if (v === null || v === undefined) return null;
  if (typeof v === 'boolean') return v ? 'Yes' : 'No';
  return String(v);
}

function fieldClass(ncesValue: string | null, blastValue: string | null): string {
  if (ncesValue === null || blastValue === null) return 'text-gray-400 dark:text-gray-600';
  if (ncesValue.trim().toLowerCase() === blastValue.trim().toLowerCase()) {
    return 'text-green-600 dark:text-green-400';
  }
  return 'text-amber-600 dark:text-amber-400';
}

export const QueueRowExpanded = ({ row }: QueueRowExpandedProps) => {
  const cand = row.matchedFields.ncesCandidateData;
  const blast = row.organization;

  const fields: FieldRow[] = [
    { label: 'Name', ncesValue: asString(cand?.name), blastValue: asString(blast.name) },
    { label: 'City', ncesValue: asString(cand?.city), blastValue: asString(blast.city) },
    { label: 'State', ncesValue: asString(cand?.state), blastValue: asString(blast.state) },
    { label: 'Zip', ncesValue: asString(cand?.zip), blastValue: null },
    { label: 'Address', ncesValue: asString(cand?.address), blastValue: null },
    { label: 'School Type', ncesValue: asString(cand?.schoolType), blastValue: null },
    { label: 'District', ncesValue: asString(cand?.district), blastValue: null },
  ];

  return (
    <div className="px-4 pb-4 pt-2 bg-gray-50 dark:bg-gray-900 border-t border-gray-200 dark:border-gray-700">
      <div className="grid grid-cols-[110px_1fr_1fr] gap-x-4 gap-y-2 text-sm">
        <div className="text-xs uppercase tracking-wide text-gray-500 dark:text-gray-400">Field</div>
        <div className="text-xs uppercase tracking-wide text-gray-500 dark:text-gray-400">NCES Candidate</div>
        <div className="text-xs uppercase tracking-wide text-gray-500 dark:text-gray-400">Blast Customer</div>

        {fields.map((f) => {
          const ncesVal = f.ncesValue ?? '—';
          const blastVal = f.blastValue ?? '—';
          const cls = fieldClass(f.ncesValue ?? null, f.blastValue ?? null);
          return (
            <div key={f.label} className="contents">
              <div className="text-gray-500 dark:text-gray-400">{f.label}</div>
              <div className={cls}>{ncesVal}</div>
              <div className={cls}>{blastVal}</div>
            </div>
          );
        })}
      </div>

      <ActionButtons rowId={row.id} />
    </div>
  );
};
